const Field = ({ touched, value, validation, children, name, setError }) => {
  let error = null;

  if (touched && validation) {
    error = validation(value);
  }

  setError(name, validation(value));

  return children({
    error,
    name,
  });
};

export default Field;
